import { useMemo } from "react";
const useSupportsHover = () => {
    return useMemo(() => !window.matchMedia("(any-hover: none)").matches, []);
};
export default useSupportsHover;
